export default "/images/ameria_bank.png?210d8c2774d3c2c698f632d577d6752e";